export default {
    name: 'DamSireView',
    components: {},
    directive: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created() {},
    methods: {},
    // third party libraries
}